import { createAsyncThunk } from '@reduxjs/toolkit';
import { $api } from '../../../shared/api';

interface FetchTasksError {
    message: string;
}

interface IsCompletedTaskPayload {
    entityUid: string;
    is_completed: boolean;
    taskId: string;
}

export const setIsCompletedTask = createAsyncThunk<
    any,
    IsCompletedTaskPayload,
    { rejectValue: FetchTasksError }
>('tasks/setIsCompletedCustomTask', async (taskPayload, thunkApi) => {
    //@ts-ignore
    const url = routable.getRoute('setIsCompletedCustomTask');
    const formattedUrl = url.replace('_customTask_', taskPayload.entityUid);

    const formData = new FormData();

    // console.log('при отправке is_completed: ', taskPayload.is_completed);

    formData.append('is_completed', JSON.stringify(taskPayload.is_completed));

    try {
        const response = await $api.post<any>(`${formattedUrl}`, formData);
        // console.log('setIsCompletedTask response: ', response);
        // return {
        //     task: response.data.data.task,
        //     newTabs: response.data.data.new_tabs,
        // };
        return {
            is_completed: taskPayload.is_completed,
            taskId: taskPayload.taskId,
        };
    } catch (error) {
        // console.log('error ', error.response.data);
        return thunkApi.rejectWithValue(
            error.response?.data || {
                message: i18next.t('Errors.UnknownError.text'),
            }
        );
    }
});
